<template>
    <div>
        <Loader />
        <analytics-header></analytics-header>
        <div class="container mt-4">
            <financial-report-statistics></financial-report-statistics>
        </div>
    </div>
</template>

<script>
    import AnalyticsHeader from './AnalyticsHeader';
    import Loader from './Loader';

    export default {
        name: "FinancialReport",
        components: {
            AnalyticsHeader,
            Loader
        }
    }
</script>


<style scoped>

</style>